/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngPrintStatusDetail', NgPrintStatusDetail);

  NgPrintStatusDetail.$inject = ['UtilsService', '$window', 'SEND_MESSAGES'];

  function NgPrintStatusDetail(UtilsService, $window, SEND_MESSAGES){
    return {
      scope: {
        currentPage: '=',
        onClickBackList: '&',
        printRecords: '=',
        currentDetail: '=',
        printHistory: '='
      },
      templateUrl: 'app/views/common/directives/print/print-status-detail.html',
      link: function(scope){
        var initPrintDetail = function(){
          scope.totalForms = 0;
          scope.propertyName = 'updatedate';
          _.each(scope.printRecords, function(record){
            scope.totalForms += record.FormCount;
          });
          scope.token = $window.sessionStorage.token;
          if(!scope.statusIsFailed()){
            scope.showfilename = UtilsService.splitFilename(scope.currentDetail.filename);
            scope.filename = 'PRINT~' + scope.showfilename;
            scope.buttonMessage = SEND_MESSAGES.FILE_AVAILABLE;
          }
          else{
            scope.buttonMessage = SEND_MESSAGES.FILE_NOT_AVAILABLE;
          }
        };

        scope.onClickBackList = function(){
          scope.currentPage.sendPage = SEND_MESSAGES.PRINTHISTORYDATA;
        };

        scope.statusIsFailed = function(){
          return (scope.currentDetail.status === 'Failed');
        };

        initPrintDetail();
      }
    };
  }
})();